import { network } from 'services/network';

import { User } from 'api/endPoints/getReport';
import { QueryResponse as Tag } from 'api/queries/getReportsTags.query';

export const getReportTemplateList = ({ filter }): Promise<ApiResponse> => {
    const url = `api/bo/reporting/getReportTemplateList`;
    return network.post(url, filter).then((response) => {
        return response.data;
    });
};

export interface ApiResponse {
    reports: ReportTemplate[];
}

export interface ReportTemplate {
    id: number;
    name: string;
    description: string;
    tags: Tag[];
    lastUpdateUser: User;
    createdBy: User;
}

export interface QueryParams {
    filter: {
        filters: FilterItem[];
    };
}

interface FilterItem {
    name: string;
    data: string[];
    operation: string;
}
